'use client';

// base
import { Suspense, useState } from 'react';

// styles
import { Column, Row } from 'styles';

// containers
import { ReqUsers, useFetchUsers, UserCreate, UserDetail } from 'domains/Admin';

// components
import { BasicModal, BasicSearch, PaginationTable, SplashLoader, TextButton } from 'components';
import { useUserColumn } from './useUserColumn';

export const AdminList: React.FC = () => {
  const [openModal, setModalOpen] = useState(false);
  const [openCreateModal, setCreateModalOpen] = useState(false);
  const [userId, setUserId] = useState<string | undefined>(undefined);

  const [keyword, setKeyword] = useState<string>('');
  const [fetchUserRequest, setFetchUserRequest] = useState<ReqUsers>({
    keywords: keyword
  });

  const { data: users, pagination, onChangePageSize } = useFetchUsers({ data: fetchUserRequest });
  const { columns } = useUserColumn();

  return (
    <Column style={{ padding: '20px 0px' }}>
      <Row style={{ justifyContent: 'space-between' }}>
        <BasicSearch
          initialValue=""
          onChange={(value) => {
            setKeyword(value);
          }}
          onSubmit={() => {
            setFetchUserRequest({ keywords: keyword });
          }}
          onReset={() => {
            setKeyword('');
            setFetchUserRequest({ keywords: '' });
          }}
        />

        <TextButton variant="contained" label="Enroll" onClick={() => setCreateModalOpen(true)} />
      </Row>

      <PaginationTable
        columns={columns}
        dataSource={users || []}
        onRowClick={(record) => {
          setUserId(record.userId);
          setModalOpen(true);
        }}
        pagination={pagination}
        onChangePageSize={onChangePageSize}
      />

      {openModal && userId && (
        <BasicModal
          open={openModal}
          onClose={() => setModalOpen(false)}
          width={800}
          height={780}
          header={'User Info'}
          body={<UserDetail isMyPage={false} userId={userId} onClose={() => setModalOpen(false)} />}
        />
      )}

      {openCreateModal && (
        <BasicModal
          open={openCreateModal}
          onClose={() => setCreateModalOpen(false)}
          width={800}
          height={780}
          header={'User Info'}
          body={<UserCreate onClose={() => setCreateModalOpen(false)} />}
        />
      )}
    </Column>
  );
};
